import React, { useState, useEffect, useRef } from 'react';
import './comment.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import DatePicker, { DateObject } from "react-multi-date-picker";
import Form from 'react-bootstrap/Form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import moment from 'jalali-moment';
import { CustomerShekayat } from '../../utils/api';
import Loader from '../loader/loader'

//icon
import Calendar from '../../assets/icons/order/calendar.svg'
import Shop from '../../assets/icons/order/shop.svg'
import Message from '../../assets/icons/comment/message.svg'
import Order from '../../assets/icons/comment/order.svg'

function Orders({ onLoad }) {
    const datePickerRef = useRef(null);
    const datePickerRef1 = useRef(null);
    const mobileDatePickerRef1 = useRef(null);
    const mobileDatePickerRef = useRef(null);
    const [dataComment, setDataComment] = useState([]);
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [customerData, setCustomerData] = useState();
    const [searchLoader, setSearchLoader] = useState(false);
    const [date, setDates] = useState([
        new DateObject().setMonth(new Date().getMonth() - 5),
        new DateObject(),
    ]);

     // isSettingTo uses only when the 'to date' datepicker opens to detect user's setting the 'to date' and prevent setting the 'from date' again.
     const [isSettingTo, setIsSettingTo] = useState(false);
     const [isSettingfrom, setIsSettingfrom] = useState(false);
 
     const onDateRangeChanged = (location, e) => {
         if (isSettingfrom) {
             handleFocus1()
             mobileHandleFocus1()
             closefromCalendar()
             mobileClosefromCalendar()
         } else if (!isSettingfrom && !isSettingTo) {
             handleFocus()
             mobileHandleFocus()
             closeToCalendar()
             mobileCloseToCalendar()
         }
         if (isSettingTo) {
             if (e[0].format().toString() == date[0].format().toString()) {
                 setDates(e);
             } else {
                 setDates((old) => {
                     old[1] = e[0];
                     return old;
                 });
                 setIsSettingTo(false);
             }
 
 
         }
         else {
             setDates(e);
         }
     };
     const onCalenderOpened = (e) => {
 
         if (e === 'to') {
             setIsSettingTo(true);
             setIsSettingfrom(false)
         }
         if (e === 'from') {
             setIsSettingfrom(true)
             setIsSettingTo(false);
 
         }
 
     };
 
     const formatDateObject = (dateObject) => {
         if (!dateObject) return "";
         const startDate = dateObject.split(' ~ ')[0];
         return startDate;
     };
     const formatDateObjectTo = (dateObject) => {
         if (!dateObject) return "";
         const endDate = dateObject.split(' ~ ')[1];
         return endDate;
     };
     const handleFocus = () => {
         if (datePickerRef.current) {
             datePickerRef.current.openCalendar();
         }
     };
     const closefromCalendar = () => {
         if (datePickerRef.current) {
             datePickerRef.current.closeCalendar();
         }
     };
     const closeToCalendar = () => {
         if (datePickerRef1.current) {
             datePickerRef1.current.closeCalendar();
         }
     };
     const mobileClosefromCalendar = () => {
         if (mobileDatePickerRef.current) {
             mobileDatePickerRef.current.closeCalendar();
         }
     };
     const mobileCloseToCalendar = () => {
         if (mobileDatePickerRef1.current) {
             mobileDatePickerRef1.current.closeCalendar();
         }
     };
     const handleFocus1 = () => {
         if (datePickerRef1.current) {
             datePickerRef1.current.openCalendar();
         }
     };
     const mobileHandleFocus = () => {
         if (mobileDatePickerRef.current) {
             mobileDatePickerRef.current.openCalendar();
         }
     };
     const mobileHandleFocus1 = () => {
         if (mobileDatePickerRef1.current) {
             mobileDatePickerRef1.current.openCalendar();
         }
     };
    // When the date range changes, update fromDate and toDate
    useEffect(() => {
        if (date && date.length === 2) {
            setFromDate(date[0]);
            setToDate(date[1]);
        }
    }, [date]);
    const commentsData = async (pay) => {
        try {
            setSearchLoader(true)
            let res = await CustomerShekayat(pay);

            if (res.status === 200) {
                getCommentsData(res.data);
                setSearchLoader(false)
            }
        } catch (error) {
            setSearchLoader(false)
        } finally {
            onLoad(); // Notify Home component that profile data is loaded
        }
    };

    const getCommentsData = async (res) => {
        setDataComment(res);
    };

    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        setCustomerData(JSON.parse(customerDatares));

        let toDateNew = moment.now();
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 6);
        let fromDateNew = fd;
        setToDate(toDateNew);
        setFromDate(fromDateNew);

        let pay = {
            fromDate: convertDateToPersian(fromDateNew),
            toDate: convertDateToPersian(new Date()),
            mobile: JSON.parse(customerDatares).mobile
        };

        commentsData(pay);
    }, []);

    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };
    const searchComment = async () => {
        let payload = {
            fromDate: convertPersianDigitsToEnglish(date[0].format()),
            toDate: convertPersianDigitsToEnglish(date[1].format()),
            mobile: customerData.mobile
        };
        commentsData(payload);
    };
    const items = [{ label: 'نظرات من' }];
    const home = { label: 'باشگاه مشتریان', url: '/' };
   
    function convertPersianDigitsToEnglish(text) {
        // Define a mapping of Persian digits to English digits
        const persianToEnglishDigits = {
            '۰': '0',
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9'
        };

        // Use a regular expression to find Persian digits and replace them
        return text.replace(/[۰-۹]/g, function (match) {
            return persianToEnglishDigits[match];
        });
    }
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    return (
        <div>
            <BreadCrumb model={items} home={home} className='bread-crumb' />
            <div className='order-body'>
                <div className='border-primary '>
                    <div className='web-filter d-flex align-items-center justify-content-between'>
                        <Form className='d-flex align-items-center justify-content-start gap-2'>
                            <Form.Group className=" col-md-4 col-lg-4 col-sm-12">
                                <Form.Label>از تاریخ</Form.Label>
                                <DatePicker
                                    range
                                    numberOfMonths={2}
                                    showOtherDays
                                    value={date}
                                    onChange={(e) => onDateRangeChanged('from', e)}
                                    onOpen={() => onCalenderOpened('from')}
                                    calendar={persian}
                                    weekDays={weekDays}
                                    locale={persian_fa}
                                    render={(value) => {
                                        const fromDateFormatted = formatDateObject(value);
                                        return <input className='form-control f-1m' readOnly onFocus={handleFocus} value={fromDateFormatted} />;
                                    }}
                                    ref={datePickerRef}
                                    onClose={() => console.log()}
                                />
                            </Form.Group>
                            <Form.Group className=" col-md-4 col-lg-4 col-sm-12">
                                <Form.Label>تا تاریخ</Form.Label>
                                <DatePicker
                                    range
                                    numberOfMonths={2}
                                    showOtherDays
                                    value={date}
                                    onChange={(e) => onDateRangeChanged('to', e)}
                                    onOpen={() => onCalenderOpened('to')}
                                    calendar={persian}
                                    weekDays={weekDays}
                                    locale={persian_fa}
                                    render={(value) => {
                                        const fromDateFormatted = formatDateObjectTo(value);
                                        return <input className='form-control f-1m' readOnly onFocus={handleFocus1} value={fromDateFormatted} />;
                                    }}
                                    ref={datePickerRef1}
                                    onClose={() => console.log()}
                                />
                                {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                            </Form.Group>
                        </Form>
                        <button disabled={searchLoader} className='btn btn-primary px-5 d-flex align-items-center justify-content-center gap-2' onClick={searchComment}> {searchLoader && <Loader />}جستجو</button>
                    </div>
                    <div className='mobile-filter'>
                        <Accordion activeIndex={0}>
                            <AccordionTab
                                header={
                                    <span className="d-flex align-items-center justify-content-between py-4 gap-2 w-full">
                                        <span style={{ fontSize: '14px', fontWeight: '700' }}>فیلترها</span>
                                        <i className="pi pi-sliders-h"></i>
                                    </span>
                                }
                            >
                                <Form className='row'>
                                    <Form.Group className=" col-md-4 col-lg-4 col-sm-12">
                                        <Form.Label>از تاریخ</Form.Label>
                                        <DatePicker
                                            range
                                            numberOfMonths={2}
                                            showOtherDays
                                            value={date}
                                            onChange={(e) => onDateRangeChanged('from', e)}
                                            onOpen={() => onCalenderOpened('from')}
                                            calendar={persian}
                                            weekDays={weekDays}
                                            locale={persian_fa}
                                            render={(value) => {
                                                const fromDateFormatted = formatDateObject(value);
                                                return <input className='form-control f-1m' readOnly onFocus={mobileHandleFocus} value={fromDateFormatted} />;
                                            }}
                                            ref={mobileDatePickerRef}
                                            onClose={() => console.log()}
                                        />
                                    </Form.Group>
                                    <Form.Group className=" col-md-4 col-lg-4 col-sm-12 mt-2">
                                        <Form.Label>تا تاریخ</Form.Label>
                                        <DatePicker
                                            range
                                            numberOfMonths={2}
                                            showOtherDays
                                            value={date}
                                            onChange={(e) => onDateRangeChanged('to', e)}
                                            onOpen={() => onCalenderOpened('to')}
                                            calendar={persian}
                                            weekDays={weekDays}
                                            locale={persian_fa}
                                            render={(value) => {
                                                const fromDateFormatted = formatDateObjectTo(value);
                                                return <input className='form-control f-1m' readOnly onFocus={mobileHandleFocus1} value={fromDateFormatted} />;
                                            }}
                                            ref={mobileDatePickerRef1}
                                            onClose={() => console.log()}
                                        />
                                        {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                                    </Form.Group>
                                </Form>
                                <button disabled={searchLoader} className='btn btn-primary w-100 mt-3 d-flex align-items-center justify-content-center gap-2' onClick={searchComment}> {searchLoader && <Loader />}جستجو</button>
                            </AccordionTab>
                        </Accordion>
                    </div>
                </div>
                {(!!dataComment && dataComment.length > 0) && dataComment.map((comment) =>

                    <div className='border-primary mt-4 pt-4'>
                        <div className='row gy-4'>

                            <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                <img src={Calendar} alt="" />
                                <h6 className='m-0 f-14 number'>تاریخ نظر: {comment.DateShekayat}</h6>
                            </div>   <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                <img src={Shop} alt="" />
                                <h6 className='m-0 f-14 number'>شعبه: {(comment.NameShobe).replace(/\d+/g, '')}</h6>
                            </div>
                            <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                <img src={Order} alt="" />
                                <h6 className='m-0 f-14 number'> نحوه ثبت نظر: {comment.RefTp}</h6>
                            </div>
                            <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                <img src={Message} alt="" />
                                <h6 className='m-0 f-14 number'>نوع نظر: {comment.ShekayatTp}</h6>
                            </div>
                            <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                <img src={Message} alt="" />
                                <h6 className='m-0 f-14 number'> متن نظر: {comment.Tp}</h6>
                            </div>

                        </div>
                    </div>
                )}
            </div>

        </div>
    );
}

export default Orders;
